<script>
import lazyLoadComponent from '@router/lazyload-component'
import { genderFilter, orderStatusFilter } from '@utils/filter-value-to-text'
import formatDate, { formatGetTime } from '@utils/format-date'
import { calcTotal, calcBasePrice } from '@utils/order-form'
import { membreLevelValidityTime } from '@utils/memberLevel'
import memberLevelDiscountMixin from '@src/mixins/memberLevelDiscountMixin'
import orderFormMixin from '@/src/mixins/orderFormMixin'
import depositOrderMixin from '@/src/mixins/depositOrderMixin'
import { cloneDeep } from 'lodash'
const initData = () => {
  return {
    params: [],
    prepaidId: '',
    fullName: '',
    gender: 'female',
    phoneCode: '+886',
    phoneNumber: '',
    email: '',
    note: '',
    status: 2,
    memberId: '',
    paymentMethod: 'Cash',
    bankType: '',
    checked: false,
    petId: '',
  }
}

export default {
  components: {
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    BaseCollapse: () => lazyLoadComponent(import('@components/BaseCollapse')),
    DepositOrderForm: () => lazyLoadComponent(import('./DepositOrderForm')),
    TotalEdit: () => lazyLoadComponent(import('./components/TotalEdit')),
    MemberSearchForm: () => lazyLoadComponent(import('./components/MemberSearchForm')),
    MemberForm: () => lazyLoadComponent(import('./components/MemberForm')),
    MemberInfo: () => lazyLoadComponent(import('./components/MemberInfo')),
    PaymentFormDialog: () => lazyLoadComponent(import('./components/PaymentFormDialog')),
    TotalStatement: () => lazyLoadComponent(import('./components/TotalStatement')),
    OrderMemberInfo: () => lazyLoadComponent(import('./components/OrderMemberInfo')),
    PetList: () => lazyLoadComponent(import('./components/PetList')),
    SignatureDialog: () => lazyLoadComponent(import('@components/SignatureDialog')),
  },
  filters: {
    formatDate,
    orderStatusFilter,
    genderFilter,
  },
  mixins: [memberLevelDiscountMixin, orderFormMixin, depositOrderMixin],
  props: {
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
    prepaidGroup: {
      type: Object,
      default: () => { },
    },
    // 基本的orderType
    // reservation ->
    // prepaid -> 包月
    // deposit -> 
    orderType: {
      type: String,
      validator: (val) => {
        return ['reservation', 'prepaid', 'deposit'].includes(val)
      },
      required: true,
    },
    // 進階orderType
    // if：包月下的複製，傳進來就是copy
    advanceOrderType: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      orderHeaderId: `orderHeader__${Math.floor(Math.random() * 10000)}`,
      headerHeight: 0,
      componentKey: 0,
      submitData: Object.assign({}, initData()),
      userSameAsMember: true,
      memberInfoShowEdit: false,
      visibleMemberSearch: true,
      tryingGetMember: false,

      // 變價或加購
      totalAllShow: false,

      paymentWay: 'offline',
      paymentDialogVisible: false,
      extraDialogVisible: false,
      tryingStore: false,

      createDepositOrderVisible: false,
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build',
      userOpenType: '',
      advanceType: {
        'copy-prepaid': this.copyPrepaidInit,
      },
      // 會員資訊
      memberInfo: {},
      memberInfoActiveTab: 'information',
      memberInfoShow: false,
      // 寵物資訊
      petInfoActiveTab: 'information',
      // 是否顯示寵物列表
      isShowPetList: true,
      petShow: false,
      petList: [],
      currentSelectPet: {},
      currentInstallmentOrder: {}
    }
  },
  computed: {
    /**
     * @description 複製包月時，要複製的資料跟新增時不一樣，所以做個advanceTypeStatus參數判斷
     */
    advanceTypeStatus() {
      return Object.keys(this.advanceType).includes(this.userOpenType)
    },
    depositReduce() {
      const { bonus, point } = this.memberInfo.depositInfo.solution2.reduceDepositTotal
      return bonus + point
    },
    prepaidPlan() {
      return this.submitData.params.find(({ type }) => type === 'prepaid-plan') || {}
    },
    prepaidPlanPrice() {
      return this.composeTotal(this.prepaidPlan)
    },
    submitPriceTotal() {
      let total = this.prepaidPlanPrice
      this.updateBasePrice()
      return calcTotal({ price: total, totalEditList: this.submitData.params })
    },
    submitRules() {
      const isTaiwan = this.submitData.phoneCode === '+886'
      return {
        phoneNumber: [
          {
            required: true,
            message: '請填寫手機號碼',
            trigger: 'blur',
          },
          {
            pattern: isTaiwan ? /^09\d{8}$/ : '',
            message: '格式請符合 09XXXXXXXX',
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: '請輸入 Email',
          },
          {
            type: 'email',
            message: '請輸入正確的 Email 格式',
          },
        ],
        fullName: [
          {
            required: true,
            message: '請輸入使用人姓名',
          },
        ],
        gender: [
          {
            required: true,
            message: '請選擇性別',
          },
        ],
      }
    },
    /* 當前訂單會員等級的折扣 */
    memberLevelDiscount() {
      if (this.submitData.params.length > 0) {
        return this.composeMemberLevelDiscount(this.submitData.params[0])
      } else {
        return 0
      }
    },
    validityTime() {
      const startedAt = this.memberInfo.level.startedAt
      const expiredAt = this.memberInfo.level.expiredAt
      return membreLevelValidityTime(startedAt, expiredAt)
    },
  },
  watch: {
    memberInfo: 'updateUserByMember',
    userSameAsMember: 'updateUserByMember',
  },
  async mounted() {
    this.$nextTick(() => {
      const interval = setInterval(() => {
        if (document.querySelector(`#${this.orderHeaderId}`) !== null) {
          clearInterval(interval)
          this.headerHeight = document.querySelector(`#${this.orderHeaderId}`).offsetHeight + 40
        }
      }, 500)
    })
    await this.advanceInit()
  },
  methods: {
    /**
     * @description 組出店家名稱
     */
    composeProductTitle(item) {
      try {
        const titles = item.prices.map(({ storeTitle }) => storeTitle) // 所有店家名稱
        const titlesSet = new Set(titles) // 取出集合
        return `(${Array.from(titlesSet).join(' | ')})` // 組成字串
      } catch (error) {
        console.error(error.message)
      }

    },
    /**
     * @description 看是否要做進階的初始化，不用就return 走一般流程
     */
    async advanceInit() {
      const userType = `${this.advanceOrderType}-${this.orderType}`
      if (Object.keys(this.advanceType).findIndex(ele => ele === userType) < 0) return
      this.userOpenType = userType
      await this.advanceType[userType]()
    },
    /**
     * @description 複製包月的初始化
     */
    async copyPrepaidInit() {
      const { memberId, id } = this.prepaidGroup
      if (!memberId || !id) return
      await this.tryToFetchMemberInfo(memberId)
      await this.fetchPrepaids()
      if (this.prepaidGroup.hasOwnProperty('params') && this.prepaidGroup.params.length > 0) {
        await this.fetchOrderComputed(id)
        const { priceId } = this.prepaidGroup.params[0]
        this.$set(this.submitData, 'prepaidId', priceId)
        this.$set(this.prepaidGroup, 'title', this.prepaidGroup.prepaidTitle)
      }
    },
    /**
     * @description 因為[複製包月]一開始已經有資料，所以訂單計算部分一開始就要顯示出來(並且不要顯示儲值金的變價)
     * pastOrderList：此張訂單的過去歷史訂單計算
     */
    async fetchOrderComputed(id) {
      const pastOrderList = await this.$store.dispatch('prepaid/fetchOrderSingle', id)
      const filterParams = pastOrderList.params.filter(ele => ele.type !== 'deposit')
      this.$set(this.submitData, 'params', filterParams)
    },
    /**
     * @description 獲取此包月的體型群組（for 訂單管理 -> 包月方案 -> copy）
     */
    async fetchPrepaids() {
      const { prepaidGroupOrdering } = this.prepaidGroup
      if (typeof (prepaidGroupOrdering) === 'number' && this.prepaidGroup.hasOwnProperty("prepaidGroupOrdering")) {
        const { prepaids } = await this.$store.dispatch('prepaid/fetchSingleGroup', prepaidGroupOrdering)
        this.$set(this.prepaidGroup, 'prepaids', prepaids)
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.leftCont) {
          this.$refs.leftCont.scrollTop = 1000
        }
      })
    },
    closeLayout() {
      this.memberInfoShowEdit = false
      this.memberInfoShow = false
    },
    resetData() {
      this.submitData.prepaidId = ''
      this.submitData.params = []
    },
    createMember(val) {
      this.memberInfo = { ...val }
      this.memberInfoShowEdit = true
    },
    clearMemberInfo() {
      this.closeLayout()
      this.memberInfo = {}
      this.resetData()
      this.visibleMemberSearch = true
    },
    /************ 客戶資訊相關 start ************/
    closeMemberInfo() {
      this.memberInfoShow = false
    },
    goToMemberInfoDetail(val) {
      this.closeAllInfo()
      this.memberInfoShow = true
      this.memberInfoActiveTab = val
    },
    /************ 客戶資訊相關 end ************/
    showMemberInfo() {
      this.memberInfoShow = true
    },
    closeAllInfo() {
      this.memberInfoShow = false
      this.petShow = false
    },
    closeEditMemberForm() {
      this.memberInfoShowEdit = false
    },
    /**
     * @description 給定會員資料，撈完帶回來顯示在畫面上(純會員資料，沒有體型之類的)
     * @param {String} memberId 
     */
    async tryToFetchMemberInfo(memberId) {
      this.tryingGetMember = true
      this.memberInfo = await this.$store.dispatch('member/fetchSingle', { memberId })
      this.closeEditMemberForm()
      this.visibleMemberSearch = false
      this.tryingGetMember = false
      this.scrollToBottom()
      this.tryToFetchPetList()
    },
    /**
     * @description 選擇體型，點選下拉之值後的function
     * @param {String} sizeId：點選到的體型Id
     */
    onSelectSizeType(sizeId) {
      const sizeItem = this.prepaidGroup.prepaids.find(({ id }) => id === sizeId)
      this.submitData.params = [this.setPrice(sizeItem)]
    },
    changeCurrentPrepaid() {
      const petSizeId = this.currentSelectPet.sizeId
      const sizeItem = this.prepaidGroup.prepaids.find(({ sizeId }) => sizeId === petSizeId)
      if (sizeItem) {
        this.submitData.prepaidId = sizeItem.id
        this.submitData.params = [this.setPrice(sizeItem)]
      } else {
        this.submitData.prepaidId = ''
        this.submitData.params = []
      }
    },
    setPrice({ sizeTitle, id, price }) {
      return {
        type: 'prepaid-plan',
        title: sizeTitle,
        price,
        priceId: id,
        qty: 1
      }
    },
    updateBasePrice() {
      let basePrice = this.prepaidPlan?.price
      basePrice = calcBasePrice({ price: basePrice, totalEditList: this.submitData.params })
      this.basePrice = basePrice
    },
    openTotalEdit() {
      this.totalAllShow = true
    },
    closeTotalAll() {
      this.totalAllShow = false
    },
    /**
     * @description 提取confirm window 成共用
     * @param {*String} mainText 主要顯示文字
     * @param {*String} seconText confirm icon 下方文字
     * @param {*Boolean} showCancelButton 是否顯示取消按鈕
     */
    async confirmWindow(mainText, seconText, showCancelButton = true) {
      return await this.$confirm(mainText, seconText, {
        confirmButtonText: '確定',
        showCancelButton,
        type: 'warning',
        center: true,
      })
        .then(result => result)
        .catch(err => {
          throw new Error(err)
        })
    },
    async handleStoreOrder() {
      try {
        await this.validateFullName(this.submitData.fullName)
        const isNegative = this.submitPriceTotal < 0
        if (isNegative) {
          this.confirmWindow('訂單金額不能小於0', '提醒', false)
          return
        }
        if (this.paymentWay === 'Deposit') {
          const total = this.submitPriceTotal
          const isDepositInsufficient = this.depositReduce < total

          if (!this.prepaidGroup.canPayByDeposit) {
            await this.confirmWindow(`此方案未設定可使用儲值點數抵扣，請問是否確定抵扣 ${total} 點？`, '抵扣未開放')
          } else {
            await this.confirmWindow(`確定要使用儲值金抵扣 ${total} 點？`, '提醒')
          }
          if (isDepositInsufficient) {
            const result = await this.confirmWindow(`儲值金餘額不足，是否加值`, '提醒')
            if (result === 'confirm') this.createDepositOrderVisible = true
            return
          }

          this.submitData.paymentMethod = 'Deposit'
          this.goToExtrafields(true)
          return
        }
        this.paymentDialogVisible = true
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 提交付款方式
     */
    async onSubmitPaymentForm(data) {
      try {
        const { paymentMethod, Card4No, PayerAccount5Code, bankType, isPaid } = data
        this.submitData = {
          ...this.submitData,
          paymentMethod,
          Card4No,
          PayerAccount5Code,
          bankType,
          status: isPaid ? 1 : 2,
          installments: paymentMethod === 'Installment' ? data.installments : []
        }
        
        await this.setInvoiceInfo(cloneDeep(this.submitData), 'prepaid-form')
        delete this.submitData.paymentStatus
        if (paymentMethod !== 'Installment') this.paymentDialogVisible = false
        this.goToExtrafields()
      } catch (error) {
        console.error(error.message)
      }

    },
    goToExtrafields() {
      if (!this.submitData.fullName) {
        this.userSameAsMember = false
      } else {
        this.userSameAsMember = true
      }
      this.handleCreateOrder()
    },
    updateUserByMember() {
      const fields = ['memberId', 'fullName', 'gender', 'phoneCode', 'phoneNumber', 'email']
      fields.forEach((field) => {
        this.submitData[field] = field === 'memberId' ? this.memberInfo.id : this.memberInfo[field]
      })
    },
    async handleCreateOrder() {
      const isBeforeExpired = this.memberInfo.level.expiredAt === null || new Date() <= new Date(formatGetTime(this.memberInfo.level.expiredAt))
      if (!isBeforeExpired) return this.errorCurrentMemberLevel()
      this.tryToCreateOrder()
    },
    /**
     * @description 修改submitData -> 因為從資料庫撈出來時為負的，所以submitdata內的price要修改為正的，才能儲存成功
     */
    modiSubmitData() {
      const { params } = this.submitData
      for (let i = 0, len = params.length; i < len; i++) {
        if (params[i].type === '+' || params[i].type === '-') {
          params[i].price = Math.abs(params[i].price)
        }
        if (params[i].type === '%' && params[i].description) {
          params[i].price = Math.abs(params[i].description)
        }
      }
    },
    async tryToCreateOrder() {
      if (this.advanceTypeStatus) {
        this.modiSubmitData()
      }
      const storeData = {
        ...this.submitData,
        basePrice: this.basePrice,
        total: this.submitPriceTotal,
        ...this.invoiceStoreData,
        invoice: this.invoiceStoreData
      }
      this.tryingStore = true

      try {
        // 一次新增一堆包月方案
        // for(let i = 0, len = 30; i < len ; i++){
        //   await this.$store.dispatch('prepaid/storeOrder', storeData)  
        // }
        this.currentInstallmentOrder = await this.$store.dispatch('prepaid/storeOrder', storeData)
        let requirePay = storeData.status === 2
        this.handleCreateSuccess(requirePay)
      } catch (error) {
        this.$message({
          type: 'error',
          message: `Server Error`,
        })
      } finally {
        this.tryingStore = false
      }
    },
    handleCreateSuccess(requirePay = false) {
      this.extraDialogVisible = false
      this.emitStore()
      this.$alert(`已發送${requirePay ? '付款' : '訂單'}連結至使用人 Email`, '訂單新增成功！', {
        confirmButtonText: '確認',
        center: true,
      })
    },
    async onCreateDepositOrderDone() {
      this.$refs.depositOrderForm.closeDrawer()
      await this.tryToFetchMemberInfo(this.memberInfo.id)
    },
    emitStore() {
      const isInstallments = this.paymentWay === 'installments'
      this.$emit('store', isInstallments)
    },
    onSubmitTotalEdit(item) {
      this.submitData.params.push({ ...item })
    },
    clearParams() {
      this.submitData.params = this.submitData.params.filter(({ type }) => !['+', '-', '%'].includes(type))
    },
    onUpdateTotalStatement({ params, deleteIds }) {
      this.clearParams()
      this.submitData.params = [...this.submitData.params, ...params]
    },
    saveTotalEdit() {
      this.totalAllShow = false
    },
    errorCurrentMemberLevel() {
      this.$alert(`超過會員等級方案"${this.memberInfo.level.title}"截止時間，請重新下單`, {
        title: `提示`,
        showClose: false,
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          this.tryToFetchMemberInfo(this.memberInfo.id)
          this.extraDialogVisible = false
        });
    },
    closeDialogAndDrawer() {
      this.paymentDialogVisible = false
      this.$emit('store')
    },
    /************ 寵物資訊相關 start ************/
    closePet() {
      this.petShow = false
      this.serviceType = ''
      this.isShowPetList = true
      this.scrollToBottom()
    },
    selectPet(id) {
      this.submitData.petId = id
      this.petShow = false
      this.isShowPetList = true
      this.scrollToBottom()
      const pet = this.petList.find((item) => {
        return item.id === id
      })
      this.currentSelectPet = pet
      this.changeCurrentPrepaid()
    },
    openSelectPet() {
      this.closeAllInfo()
      this.serviceType = ''
      this.petShow = true
      this.isShowPetList = true
    },
    async tryToFetchPetList() {
      this.petList = await this.$store.dispatch('member/fetchPetList', {
        paginate: 0,
        memberId: this.memberInfo.id,
      })
    },
    goToPetInfoDetail(val) {
      this.petInfoActiveTab = val.alias
      this.closeAllInfo()
      this.petShow = true
      this.isShowPetList = val.isShowPetList
    },
    /************ 寵物資訊相關 end ************/
  },
}
</script>
<template>
  <div v-loading="tryingGetMember" :class="$style.orderformSection">
    <div v-if="!totalAllShow" class="orderformSection__all">
      <div class="orderformSection__left">
        <div :id="orderHeaderId" :class="$style.header">
          <h5 class="Jost">購買{{ $t('prepaid.BASE') }}方案</h5>
          <div class="d-flex justify-content-between fw-regular fs-4 text-secondary">
            <div class="Jost">{{ prepaidGroup.title }}</div>
            <div>
            <div class="Jost">購買項目 可抵用次數:<span class="text-primary">{{ prepaidGroup.times }}次</span></div>
            <div v-if="prepaidGroup.bonusTimes" class="Jost">贈送項目 可抵用次數:<span class="text-primary">{{ prepaidGroup.bonusTimes }}次</span></div>
            </div>
          </div>
        </div>
        <div ref="leftCont" class="orderformSection__left__content" :style="`height:calc(100vh - ${headerHeight}px)`">
          <template v-if="visibleMemberSearch">
            <MemberSearchForm @create="createMember" @update="tryToFetchMemberInfo" />
          </template>
          <div v-else element-loading-background="rgba(0, 0, 0,0)" style="min-height: 300px; padding-top: 20px"
            class="info-section">
            <template v-if="memberInfo.id">
              <!-- 客戶資訊 -->
              <el-button class="is-round" style="margin-bottom: 20px" @click="clearMemberInfo">
                <BaseIcon name="arrow-left" />
                重新搜尋
              </el-button>
              <template>
                <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
                  <template v-slot:title>
                    <span>
                      <BaseIcon icon-style="fal" name="address-card"
                        :class="[$style['header-icon-left'], 'fs-2xl', 'mr-3', 'align-text-bottom']" />
                      客戶資訊
                    </span>
                  </template>
                  <OrderMemberInfo :member-info="memberInfo" @toDetail="goToMemberInfoDetail" />
                </BaseCollapse>
              </template>
              <!-- 寵物資訊 -->
              <!-- FIX ME 未來會需要 -->
              <!-- <template>
                  <BaseCollapse expanded is-order :order-theme="true">
                    <template v-slot:title>
                      <span><BaseIcon icon-style="fal" name="bone" :class="[$style['header-icon-left'] ,'fs-lg', 'mr-3']" style="transform: rotate(-45deg)"/> 寵物資訊 </span>
                    </template>
                    <OrderPetInfo
                      :default-value="submitData"
                      :pet-list="petList"
                      type="prepaid" 
                      @toDetail="goToPetInfoDetail"
                      @onSelect="openSelectPet"
                    />
                  </BaseCollapse>
                </template> -->
              <!-- 選擇體型 -->
              <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
                <template v-slot:title>
                  <span>
                    <BaseIcon icon-style="fal" name="piggy-bank" :class="[$style['header-icon-left'], 'fs-lg', 'mr-3']" />
                    選擇{{ $t('reserve.SIZE_TO_CLIENT') }}
                  </span>
                </template>
                <!-- FIX ME 未來會需要 -->
                <!-- <p v-if="!submitData.petId" class="text-center">請先選擇寵物</p> -->
                <div class="el-form-item--white-bg mb-4">
                  <!-- FIX ME 未來會需要 -->
                  <!-- <div class="mb-2">包月方案 <el-checkbox v-model="submitData.checked">可供同體型使用方案</el-checkbox></div> -->
                  <el-select v-model="submitData.prepaidId" :placeholder="`請選擇${$t('reserve.SIZE_TO_CLIENT')}`"
                    @change="onSelectSizeType">
                    <el-option v-for="(item, index) in prepaidGroup.prepaids" :key="index" :value="item.id"
                      :label="`${item.sizeTitle}・ ${item.price}元`">
                      <div class="d-flex justify-content-between">
                        <span>{{ `${item.sizeTitle}・ ${item.price}元` }}</span>
                        <span>{{ composeProductTitle(item) }}</span>
                      </div>
                    </el-option>
                  </el-select>
                  <div class="mt-4 my-2">備註（ex:{{ $t('reserve.CLIENT') }}{{ $t('reserve.NAME_TO_EMPTY') }})</div>
                  <el-input v-model="submitData.note" type="textarea" :rows="3" placeholder="請輸入"
                    class="bg-white is-border is-round">
                  </el-input>
                </div>
              </BaseCollapse>
            </template>
          </div>
        </div>
      </div>

      <div class="orderformSection__right">
        <template>
          <!-- 客戶編輯 -->
          <template v-if="memberInfoShowEdit">
            <MemberForm :default-value="memberInfo" @update="tryToFetchMemberInfo" @close="closeEditMemberForm" />
          </template>
          <!-- 客戶資訊 -->
          <template v-if="memberInfoShow && !memberInfoShowEdit">
            <MemberInfo :member-info="memberInfo" :member-info-active-tab="memberInfoActiveTab"
              @update="tryToFetchMemberInfo" @close="closeMemberInfo" />
          </template>
        </template>
        <!-- 寵物選擇 -->
        <template v-if="petShow">
          <PetList :active-id="submitData.petId" :member-info="memberInfo" :pet-info-active-tab="petInfoActiveTab"
            :is-show-pet-list="isShowPetList" @close="closePet" @selected="selectPet"
            @update="tryToFetchMemberInfo(memberInfo.id)" />
        </template>
        <!-- 變價 -->
        <template>
          <div :class="$style.total">
            <div class="total__cont">
              <TotalStatement enabled-edit :member-info="memberInfo" order-type="prepaid" :default-value="submitData"
                @update="onUpdateTotalStatement">
                <div v-if="prepaidPlan.priceId" class="btn-group-inline" :class="$style.bottom"
                  style="padding: 0  0 30px 0px;background-color: $color-line;">
                  <el-button plain class="is-round" @click="openTotalEdit">價格編輯與折扣</el-button>
                </div>
              </TotalStatement>
            </div>
            <div class="total__bottom">
              <div style="display: flex; margin-bottom: 10px">
                <h6>付款方式</h6>
              </div>
              <el-radio-group v-model="paymentWay" class="isStyleBorderRound">
                <el-row :gutter="20">
                  <el-col :span="12"><el-radio v-if="$hasDeposit()" label="Deposit" border>儲值點數抵扣</el-radio></el-col>
                  <el-col :span="12"><el-radio v-if="$cashFlowSettingPass()" label="online"
                      border>線上付款</el-radio></el-col>
                  <el-col :span="12"><el-radio label="offline" border>線下付款</el-radio></el-col>
                  <el-col :span="12"><el-radio label="installments" border>分期付款</el-radio></el-col>
                </el-row>
              </el-radio-group>
            </div>
          </div>
        </template>
      </div>
      <!-- 底部按鈕 -->
      <div class="orderformSection__bottom">
        <div style="display: flex; align-items: center">
          <BaseStateLabel class="is-border" :state="defaultValue.status | orderStatusFilter('color')">{{
            defaultValue.status | orderStatusFilter('text') }}</BaseStateLabel>
          <div style="padding-left: 20px" class="text-secondary Jost fw-medium">
            應付 NT${{ submitPriceTotal }}
            <div v-if="!prepaidPlan.priceId" class="text-muted-0" style="padding-top: 5px">未選擇{{ $t('member.BODY_TO_TYPE')
            }}</div>
          </div>
        </div>
        <el-button class="is-round orderformSection__bottom__btn" type="primary"
          :disabled="tryingStore || !prepaidPlan.priceId" :loading="tryingStore" @click="handleStoreOrder">
          購買{{ $t('prepaid.BASE') }}方案
        </el-button>
      </div>
    </div>
    <!-- 變價或加購 -->
    <div v-if="totalAllShow" class="orderformSection__all">
      <div class="orderformSection__right" style="border-right: #dcdfe6 1px solid">
        <div class="orderformSection__right__header">
          <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click.stop="closeTotalAll">
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
          <h4 class="orderformSection__right__title">
            <div class="inline-between" style="padding-right: 15px; align-items: center">
              <span> 價格編輯與折扣 </span>
            </div>
          </h4>
        </div>

        <div class="orderformSection__right__content" style="padding: 0 0 20px 0">
          <TotalStatement enabled-edit order-type="prepaid" :member-info="memberInfo" :default-value="submitData"
            @openTotalEdit="openTotalEdit" @update="onUpdateTotalStatement">
            <div :class="$style.bottom" style="padding: 0 0 26px;">
              <div class="btn-group-inline">
                <el-button class="is-round" type="primary" @click="saveTotalEdit">儲存</el-button>
              </div>
            </div>
          </TotalStatement>
        </div>
      </div>
      <div class="orderformSection__left" style="border: 0">
        <div class="orderformSection__left__content" style="padding-bottom: 0">
          <!-- 變價 -->
          <TotalEdit @submit="onSubmitTotalEdit" />
        </div>
      </div>
    </div>

    <!-- 選擇付款方式和訂單狀態 -->
    <PaymentFormDialog :visible.sync="paymentDialogVisible" :payment-way="paymentWay" :loading="tryingStore" :price-total="submitPriceTotal" :installment-order="currentInstallmentOrder.items"
      @submit="onSubmitPaymentForm" @close="closeDialogAndDrawer" />

    <!-- 簽名請款 -->
    <SignatureDialog :one-step="true" :start-tab="1" :member-info="memberInfo" :props-store-invoice-setting="1"
      :visible.sync="signDialogVisible" :order="{ ...submitData }" @closeSignature="closeSignature"
      @closeSignaturDialog="closeSignaturDialog" />

    <!-- 新增儲值金訂單 -->
    <el-drawer ref="depositOrderForm" class="only-close" :class="{ 'appStyle': appStyle }"
      :visible.sync="createDepositOrderVisible" :append-to-body="true" :size="$root.isSmallDevice ? '100%' : '90%'"
      destroy-on-close :modal-append-to-body="false" :wrapper-closable="false" custom-class="order-drawer">
      <DepositOrderForm :order-member-id="memberInfo.id" order-type="deposit" @store="onCreateDepositOrderDone" />
    </el-drawer>
  </div>
</template>
<style lang="scss" module>
@import '@design';

.orderformSection {

  // display: flex;
  // flex-wrap: wrap;
  // height: 100%;
  :global {
    .form-block-title {
      font-size: 16px;
      padding-bottom: 0;
      margin-top: 0;
    }

    .el-form-item {
      // margin-bottom: 10px;
    }

    .el-tabs__active-bar {
      background-color: $color-primary !important;
    }

    .info-section {
      padding: 30px 40px;

      @include max-lg {
        padding: 15px 20px;
      }
    }

    .orderformSection {
      &__all {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        height: 100%;
        // display: none;
      }

      &__left {
        width: 57%;
        border-right: $color-border-base 1px solid;
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        background: $color-line;

        &__content {
          height: 100vh;
          overflow: auto;

          padding-bottom: 90px;
        }
      }

      &__right {
        position: relative;
        width: 43%;
        height: calc(100vh);
        overflow: hidden;
        background: $color-line;

        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }

        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;

          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }

          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }

          .el-tabs__nav-wrap::after {
            display: none;
          }

          .el-tabs__header {
            margin-bottom: 0;
          }

          .el-tabs--top {
            margin-left: 60px;

            @include max-lg {
              margin-left: 30px;
            }
          }
        }

        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;

          @include max-lg {
            padding: 20px;
          }
        }
      }

      &__bottom {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 30px;
        background: #fff;
        box-shadow: 0 -5px 5px rgba(#eee, 0.3);
        z-index: 999;

        @include touch {
          position: static;
          // position: fixed;
        }

        &__btn {
          width: 40%;
        }

        &__btn-item {
          min-width: 132px;
          // width: 100%;
        }
      }
    }
  }
}

.header {
  margin-top: 5px;
  // margin-bottom: 30px;
  padding-left: 60px;
  padding-right: 40px;
  padding-bottom: 10px;
  border-bottom: $color-border-base 1px solid;

  @include max-lg {
    padding-right: 20px;
  }

  :global {
    h5 {
      font-size: 18px;
    }
  }
}

.title:not(:first-child) {
  margin-top: 30px;
}

.infoList {
  // margin-bottom: 30px;
  padding-top: 5px;

  // border-bottom: 1px solid $color-border-base;
  // font-size: 16px;
  :global {
    .muted {
      color: $color-text-secondary;
    }

    .el-tag+.el-tag {
      margin-left: 10px;
    }

    .infoList {
      &__title {
        font-weight: 500;
        margin-bottom: 20px;
      }

      &__item {
        margin-bottom: 15px;
      }

      &__row {
        margin-bottom: 20px;
      }
    }
  }
}

.total {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 100%;
  z-index: 1;

  @include touch {
    position: static;
  }

  :global {
    .total {
      &__cont {
        // height: calc(100% - 80px);
        height: calc(100% - 267px);

        @include touch {
          height: auto;
        }
      }

      &__bottom {
        padding: 30px 30px;
        position: absolute;
        bottom: 80px;
        width: 100%;
        border-top: $color-border-base 1px solid;

        h6 {
          margin-top: 0;
        }

        :global {
          // .el-radio-group {
          //   display: flex;
          // }
          // .el-radio {
          //   margin-right: 0;
          //   padding-right: 12px;
          //   border-radius: 7px;
          //   margin-left: 0;
          //   width: 100%;
          //   background-color: #fff;
          // }
        }
      }
    }
  }
}

.bottom {
  /* position: absolute;
  bottom: 0; */
  width: 100%;
  padding: 0 30px 0;

  @include touch {
    position: static;
  }
}
</style>
